import { State } from '../../reducers/rootReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const trackingSelector = (state: State): any => state.tracking

export default trackingSelector
